// The IE polyfill must be the first line in the entry file
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as Sentry from '@sentry/browser';
import CustomMiddleware from 'components/middleware/CustomMiddleware';
import * as React from 'react';
import ReactDOM from 'react-dom';
import TagManager, { TagManagerArgs } from 'react-gtm-module';
import '../node_modules/@busybusy/webapp-react-ui/dist/styles/index.scss';
import Middleware from './components/middleware/Middleware';
import App from './containers/app/App';
import './i18n';
import * as serviceWorker from './serviceWorker';
import './styles/index.scss';
import './wdyr';

const tagManagerArgs: TagManagerArgs = {
  gtmId: `${process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID}`,
};
TagManager.initialize(tagManagerArgs);

const sentryArgs: Sentry.BrowserOptions = {
  dsn: 'https://42391f38446b4ab9bd619b7eadac3e04@o30165.ingest.sentry.io/5257002',
  release: `webapp-react@${process.env.REACT_APP_VERSION}`,
  environment: process.env.REACT_APP_ENV,
};
Sentry.init(sentryArgs);

const WrappedApp: React.FunctionComponent = () => (
  <Middleware>
    <CustomMiddleware>
      <App />
    </CustomMiddleware>
  </Middleware>
);

ReactDOM.render(<WrappedApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
